import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetChatList = {
  getChatList: { data: null, loading: false, error: null },
};

export const getChatList = createAsyncThunk('user/getChatList', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/chat/chats`, {
      params: { ...data, subtype: undefined, ordering: '-has_unread_messages,-last_message_time' },
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      paramsSerializer: {
        indexes: null, // null вместо квадратных скобок
      },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetChatList = {
  [getChatList.pending]: (state) => {
    // state.getChatList.data = null;
    state.getChatList.loading = true;
    state.getChatList.error = null;
  },
  [getChatList.fulfilled]: (state, action) => {
    state.getChatList.loading = false;
    state.getChatList.data = action.payload;
    state.getChatList.error = null;
  },
  [getChatList.rejected]: (state, action) => {
    state.getChatList.loading = false;
    state.getChatList.error = action.payload;
  },
};
